import script from "./NavigationTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&setup=true&lang=js"

import "./NavigationTabs.vue?vue&type=style&index=0&id=10480166&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10480166"]])

export default __exports__